import React, { useState, useEffect } from 'react';

import './globalsRealize';
import './injectRealize';
import "./static/js/app/i18n";
import "./static/js/app/bpm_integration/attach_document_action_listener";
import "./static/js/app/bpm_integration/multiple_complete_activity_action";
import "./static/js/app/bpm_integration/set_field_properties_event_listener";
import "./static/js/app/i18n/locale_handler/locale_handler";

import EventHandlerPostMessageProxy from './static/js/app/post_message/event_handler_post_message_proxy';
import ActivityFormContainer from './static/js/app/process/components/activity_form_container';
import { getParamUrl } from './static/js/app/utils/query_string_parser';
import { getCookie, setCookie } from "./static/js/app/utils/cookie_utils";
import { ticketMock } from './shared/ticketMock';
import api from './services/api';
import { HOST_NAME_API } from './shared/serverInfo';

import './App.scss';

if (process.env.NODE_ENV === 'production') {    
  require(`./static/js/global_imports.prod.js`);
}
else {    
  require(`./static/js/global_imports.dev.js`);
}

let controlDispatchTouch = true;

function App() {
  const [authMobile, setAuthMobile] = useState({ ticketSSO: "", clientId: "" });
  const tokenMobile = getParamUrl("token");  
  const clientId = getCookie("client-id");
  const props = {
    processIds: {
      processInstanceId: Number(getParamUrl("processInstanceId")),
      cycle: Number(getParamUrl("cycle")),
      activityInstanceId: Number(getParamUrl("activityInstanceId"))
    },
    actionEmail: getParamUrl("actionEmail"),    
    ticket: getCookie("LecomSSOTicket") || authMobile.ticketSSO || ticketMock,
    isTestMode: getCookie("testMode") === "true",
    language: getParamUrl("language") || getCookie("LecomUserLanguage") || "pt_BR",
    isMobile: getParamUrl("isMobile") ? getParamUrl("isMobile") === "true" : false,    
    displayFormHeader: getParamUrl("displayFormHeader") ? getParamUrl("displayFormHeader") === "true" : true,
    uuid: getParamUrl("uuid"),
    dataPrintEnabled: false,
    gatewayUrl: '',
    isECMLicenseFull: false,
    lecomBpmUrl: '',
    timeZone: "America/Sao_Paulo"
  };    

  EventHandlerPostMessageProxy.init();           

  useEffect(() => {           
    if (tokenMobile && !authMobile.ticketSSO) {
      api.get(`${HOST_NAME_API}/form/authenticationMobile/${tokenMobile}${clientId ? `/${clientId}` : ''}`)
        .then(response => {                      
          setCookie('client-id', response.data.clientId);
          localStorage.setItem("ticket", response.data.ticketSSO);
          setAuthMobile(response.data);          
        });        
    }    
    
    document.addEventListener("click", (e) => {      
      e.stopPropagation();
      
      if (controlDispatchTouch) {        
        controlDispatchTouch = false;        

        setTimeout(() => {
          api.get(`${HOST_NAME_API}/form/touch`, { headers: { "ticket-sso": props.ticket } })
            .finally(() => {                                  
              controlDispatchTouch = true;
            });                    
        }, 300000);      
      }            
    });    
  }, []);  
  
  if (tokenMobile && !authMobile.ticketSSO) {
    return null;
  }

  return (
    <div className="App">      
      <ActivityFormContainer { ...props } />      
    </div>
  );
}

export default App;